import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useUpdateBillingAddressForm } from "@Light/components/page/form/UpdateBillingAddress";
import {
  useHeaderBackNavigate,
  useHeaderTitle,
} from "@Light/components/page/header/context";
import { MutationButton } from "@Light/components/page/MutationButton";
import { useScaffold } from "@Light/scaffold";
import React from "react";

export const BACK_ROUTE = "/account/details/";

export type UpdateBillingAddressProps = {};

export const UpdateBillingAddress: React.FC<
  UpdateBillingAddressProps
> = ({}) => {
  const scaffold = useScaffold();
  const { onSubmit, disabled, mutation, form } = useUpdateBillingAddressForm();

  useHeaderTitle("Update your billing address");
  useHeaderBackNavigate(BACK_ROUTE);

  if (mutation.isSuccess) {
    const Navigate = scaffold.system.navigate;
    return <Navigate to={BACK_ROUTE} />;
  }

  const PageBody = scaffold.page.pageBody;
  return (
    <form>
      <PageBody
        footerAfterContent={true}
        footer={
          <ButtonFooter>
            <MutationButton
              size="lg"
              mutation={mutation}
              mutateButtonText="Confirm"
              mutate={onSubmit}
              errorMessage="Error updating billing address. Please try again later."
              disabled={disabled}
            />
          </ButtonFooter>
        }
      >
        <div className="pt-8 flex flex-col gap-4">{form}</div>
      </PageBody>
    </form>
  );
};
